<mat-card appearance="outlined"
          class="sample-details"
          ngClass.lt-md="sample-details-sm"
          ngClass.lt-sm="sample-details-xs">

  <mat-card-content fxLayout="row"
                    fxLayoutAlign="space-between"
                    fxLayout.lt-md="column"
                    fxLayoutGap="16px"
                    class="card-content">
    <section fxFlex="46%">
      <h2 class="heading">Details</h2>
      <ifc-horizontal-list [items]="detailsListItems"></ifc-horizontal-list>
    </section>
    <section fxFlex="46%">
      <h2 class="heading">Cost of capital</h2>
      <ifc-horizontal-list [items]="costListItems"
                           (actionClicked)="onActionClicked($event)"></ifc-horizontal-list>
    </section>
  </mat-card-content>
</mat-card>
